"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
function getReviewerSetting(reviewerIds, reviewerType) {
    switch (reviewerType) {
        case entity_1.ReviewerType.NONE:
        case entity_1.ReviewerType.MANAGER:
            return {
                reviewerType
            };
        default:
            return {
                reviewerIds: reviewerIds,
                reviewerType
            };
    }
}
exports.getReviewerSetting = getReviewerSetting;
//# sourceMappingURL=getReviewerSetting.js.map